import type { FC } from 'react'

import { CustomerServiceOutline24 } from '@sok/design-system'
import { NextLink } from 'components/NextLink'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import {
  StoreInfoCard,
  StoreInfoCardItem,
  StoreInfoCardItemDescription,
  StoreInfoCardItemWrapper,
  StoreInfoCardTitle,
} from './StoreInfoCard'

const StyledStoreInfoCard = styled(StoreInfoCard).attrs({ as: 'address' })({
  fontStyle: 'normal',
})

export const OnlineStoreContactInfo: FC = () => {
  const { t } = useTranslation()

  return (
    <StyledStoreInfoCard>
      <StoreInfoCardTitle>{t('Online store contact info')}</StoreInfoCardTitle>

      <StoreInfoCardItem>
        <StoreInfoCardItemDescription>
          <span>{t('Is your question about a delivery or a payment?')}</span>
        </StoreInfoCardItemDescription>
      </StoreInfoCardItem>

      <NextLink href="https://www.s-kaupat.fi/asiakaspalvelu">
        <StoreInfoCardItemWrapper>
          <StoreInfoCardItem>
            <CustomerServiceOutline24 />
            <span>{t('Online store contact info')}</span>
          </StoreInfoCardItem>
        </StoreInfoCardItemWrapper>
      </NextLink>
    </StyledStoreInfoCard>
  )
}
